var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24351 1.13696H5.49716V2.88331H7.24351V1.13696Z",
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7474 1.13696H17.0011V2.88331H18.7474V1.13696Z",
    fill: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1387 14.3438C12.7866 14.3438 13.3118 13.8186 13.3118 13.1707C13.3118 12.5228 12.7866 11.9976 12.1387 11.9976C11.4908 11.9976 10.9656 12.5228 10.9656 13.1707C10.9656 13.8186 11.4908 14.3438 12.1387 14.3438Z",
    fill: "#8A92A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3191 2.88367H3.90351C2.9752 2.88367 2.22266 3.63621 2.22266 4.56452V21.4167C2.22266 22.345 2.9752 23.0976 3.90351 23.0976H20.3191C21.2474 23.0976 22 22.345 22 21.4167V4.56452C22 3.63621 21.2474 2.88367 20.3191 2.88367Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 8.77747H22",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72908 14.3449C8.37696 14.3449 8.90218 13.8197 8.90218 13.1718C8.90218 12.5239 8.37696 11.9987 7.72908 11.9987C7.08119 11.9987 6.55597 12.5239 6.55597 13.1718C6.55597 13.8197 7.08119 14.3449 7.72908 14.3449Z",
    fill: "#8A92A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1387 18.7041C12.7866 18.7041 13.3118 18.1789 13.3118 17.531C13.3118 16.8831 12.7866 16.3579 12.1387 16.3579C11.4908 16.3579 10.9656 16.8831 10.9656 17.531C10.9656 18.1789 11.4908 18.7041 12.1387 18.7041Z",
    fill: "#8A92A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72908 18.7041C8.37696 18.7041 8.90218 18.1789 8.90218 17.531C8.90218 16.8831 8.37696 16.3579 7.72908 16.3579C7.08119 16.3579 6.55597 16.8831 6.55597 17.531C6.55597 18.1789 7.08119 18.7041 7.72908 18.7041Z",
    fill: "#8A92A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 14.3449C17.1528 14.3449 17.678 13.8197 17.678 13.1718C17.678 12.5239 17.1528 11.9987 16.5049 11.9987C15.857 11.9987 15.3318 12.5239 15.3318 13.1718C15.3318 13.8197 15.857 14.3449 16.5049 14.3449Z",
    fill: "#8A92A6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 18.7041C17.1528 18.7041 17.678 18.1789 17.678 17.531C17.678 16.8831 17.1528 16.3579 16.5049 16.3579C15.857 16.3579 15.3318 16.8831 15.3318 17.531C15.3318 18.1789 15.857 18.7041 16.5049 18.7041Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.439b39d65aa5e468fbb8448ba1b8d8ad.svg";
export { ForwardRef as ReactComponent };